<script setup>
import QuestionText1 from "@/components/Base/QuestionText1.vue";
import {defineProps, defineEmits, computed, toRefs, ref} from "vue";
import {Spin} from "ant-design-vue"
import moment from "moment/moment";
import Pagination from "../Base/PaginationComponent.vue";
import axios from "axios";
import {useCompetitionToProjectInfo} from "@/stores/competitionToProjectInfo";
import ImageRender from "@/components/Base/ImageRender.vue";
import ImageService from "@/services/ImageService";

const props = defineProps({
  competitionMode: {
    type: Boolean,
    required: false
  },
  questionMode: {
    type: Boolean,
    required: false
  },
  competitions: {
    type: Array,
    required: true
  },
  isLoading: {
    type: Boolean
  },
  totalCompetitions: {},
  errors: {},
  type: {
    type: String,
    default: 'project'
  },
  entityId: {}
});

const {competitionMode, questionMode, errors, type, entityId} = toRefs(props);

let selectedCompetitionId = ref(0);

const emit = defineEmits(['loadCompetitions', 'close']);

let componentLoading = ref(false);
let currentPageNum = ref(0);

const store = useCompetitionToProjectInfo();

async function getSelectedCompetition(id) {
  //const response = await axios.get('/api/competitions/'+id);
  let response;
  if (store.selectedCompetition?.is_bussiness_area) {
    response = await axios.get('/competition/apiGetCompetition/' + id + '/' + window.currentUserId);
  } else {
    response = await axios.get('/competition/apiGetCompetition/' + id + '/' + window.projectId);
  }

  store.selectedCompetition = response?.data;
}

async function setCompetitionId(id) {
  componentLoading.value = true;

  store.selectedCompetition = {};
  selectedCompetitionId.value = id;

  await getSelectedCompetition(id);

  setTimeout(() => {
    componentLoading.value = false;
  }, 1000);
}

function updateCompetitions(pageNum) {
  currentPageNum.value = pageNum;
  emit('loadCompetitions', pageNum)
}

function formatCompetitionDate(date) {
  return moment(date).format('M/D/YYYY')
}

function closeModal() {
  emit('close');
}

async function makeProjectInfo(categoryId, isProjectInfoSubmitted) {
  if (!isProjectInfoSubmitted || isProjectInfoSubmitted === '0') {
    componentLoading.value = true;

    let url = '';
    if (type.value === 'project') {
      url = '/competition/apiAddProject/' + selectedCompetitionId.value + '/' + window.projectId + '/' + categoryId;
    }

    if (type.value === 'user') {
      url = '/competition/apiAddUserCompetition/' + selectedCompetitionId.value + '/' + entityId.value + '/' + categoryId;
    }

    const response = await axios.get(url, {
      headers: {
        'Accept': 'application/ld+json',
      }
    })
    if (response.data['error']) {
      alert(response.data['error'])
    }

    await getSelectedCompetition(selectedCompetitionId.value);
    componentLoading.value = false;
  }
}

const selectedCompetitionItem = computed(() => {
  return store.selectedCompetition ?? {};
})

const isGlobalLoading = computed(() => {
  return store.isLoading ?? false;
})

const isErrorsNull = computed(() => {
  let res = false;
  if (typeof errors.value === 'object') {
    return Object.keys(errors.value).length === 0
  } else if (Array.isArray(errors)) {
    return errors.value.length === 0;
  }
  return res;
})

const projectId = computed(() => {
  return window.projectId;
})

function get_uploaded_image_asset(path) {
	return ImageService.getCompetitionImagePath(path);
}

</script>

<template>
  <div>
    <template v-if="competitionMode">
      <div>
        <div v-if="selectedCompetitionId === 0">
          <h1 style="margin-bottom: 35px;">Конкурсы</h1>
          <template v-if="isLoading">
            <Spin></Spin>
          </template>
          <template v-else>
            <div class="columns is-multiline">
              <div v-for="(competition, index) in competitions" :class="index % 2 === 0 ? 'col1' : 'col2'"
                   class="column competition_wrapper is-5-desktop" :data-competitionid="competition.id"
                   :key="competition.id">
                <div class="competition_wrapper_inner" style="position: relative">
                  <div class="competition-image-wrapper">
<!--	                  <ImageRender-->
<!--		                  :src="get_uploaded_image_asset(competition.avatar)"-->
<!--		                  class-name="competition_image"-->
<!--	                  />-->
                    <img class="competition_image" :src="competition.clearAvatar">
                  </div>
                  <div class="competiton_order_button_div">
	                  <template v-if="competition.id === 128">
                      <a :href="'/project/'+projectId+'/update_complete/'+competition.id" class="button2 competiton_order_button">Подать заявку</a>
	                  </template>
	                  <template v-else>
                      <a @click="setCompetitionId(competition.id)"
                         class="button2 competiton_order_button">Подать заявку</a>
	                  </template>
                  </div>
                </div>

                <div class="competition-info">
                  <p class="competition-type">{{ competition.napravlenie }}</p>

                  <!--																		:href="'/competition/single/'+competition.id"-->
                  <p class="competition-title__wrapper" :data-competitionId="competition.id"><a @click.prevent="setCompetitionId(competition.id)"
                                                           class="competition-title">{{ competition.name }}</a></p>
                  <!--                                    <p style="margin-bottom: 0;"><a class="competition-title"-->
                  <!--                                                                    @click="setCompetitionId(competition.id)">Подать-->
                  <!--                                        заявку</a></p>-->
                  <!--                                    <p><a target="_blank" class="competition-title"-->
                  <!--                                          :href="'/competition/single/' + competition.id">Ссылка на конкурс</a></p>-->
                </div>

                <div class="competition_do">
                  ДО<br>
                  {{ formatCompetitionDate(competition.endDate) }}
                </div>
              </div>
            </div>
            <Pagination
                perPage=10
                @updateParentData="updateCompetitions"
                :totalItems="totalCompetitions"
                :currentPageNum="currentPageNum"
            ></Pagination>
          </template>
        </div>
        <div class="choise_category" v-else>
          <!--                    <p v-if="windowCompetitionId?.length === 0"><a @click="selectedCompetitionId = 0">Выбрать другой-->
          <!--                        конкурс</a>-->
          <!--                    </p>-->
          <template v-if="selectedCompetitionItem?.isUserAgeRight">
            <h1 v-if="isErrorsNull && !componentLoading">Выберите категорию конкурса {{
								selectedCompetitionItem?.name
              }}</h1>
            <div v-if="componentLoading">
              <Spin></Spin>
            </div>
            <div v-else>
              <div class="errors-block" v-if="!isErrorsNull">
                <b style="color:#000;">Для этого конкурса нужно заполнить следующие поля:</b>
                <ul>
                  <li v-for="(error,index) in errors" :key="index" v-html="error.text"></li>
                </ul>
                <p><a @click="closeModal">Заполнить поля</a></p>
              </div>
              <div v-else>
                <p class="category_select"
                   :class="category.isProjectInfoSubmitted === '1' ? 'category_select_active' : ''"
                   @click="makeProjectInfo(category.id, category.isProjectInfoSubmitted)"
                   v-for="category in selectedCompetitionItem?.categories" :key="category.id"><i
                    v-if="category.isProjectInfoSubmitted === '1'"
                    style="color: green; margin-right: 10px;"
                    class="fas fa-check-square"></i> {{ category.name }} <span
                    v-if="category.isProjectInfoSubmitted === '1'">(Заявка подана)</span></p>
              </div>
            </div>
          </template>
          <template v-else>
            <div>{{ selectedCompetitionItem?.competitionData?.['age_description'] }}</div>
          </template>

        </div>
      </div>
    </template>
    <template v-if="questionMode">
      <QuestionText1 />
    </template>
  </div>
</template>


<style scoped>


.ant-modal-wrap {
    z-index: 2000;
}

.competition_wrapper {
    position: relative;
    max-width: 315px;
}

.ant-modal .columns.is-multiline .col1 {
    margin-right: 15px;
    margin-bottom: 40px;
}

.competiton_order_button_div {
    display: none;
}

.competiton_order_button_div .button2 {
    padding-left: 15px;
    padding-right: 15px;
}

.competiton_order_button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: 10px;
}

.competition-info {
    background: #FEF4E5;
    padding: 20px;
}

.competition-image-wrapper {
    position: relative;
    display: flex;
    border-bottom: 5px solid #F69F22;
}

.choise_category h1 {
    font-size: 21px;
}

.competition-title__wrapper {
    line-height: 1;
}

.competition-title {
    font-size: 16px;
}

.competition-type {
    margin-bottom: 10px;
}

.competition_do {
    text-align: center;
}

.category_select {
    font-size: 18px;
}

.category_select:hover {
    color: #F69F22;
    cursor: pointer;
}

.competition_wrapper_inner:hover .competiton_order_button_div {
    display: block;
}

.errors-block {
    width: 95%;
    margin: auto;
}
</style>